module.exports = __webpack_public_path__ + "img/cloverGray.07a414c9.png";